import React from 'react';

import {
	CHAT_ROOMS_GNDI_SAO_PAULO,
	PRODUCT_CODE,
	PRODUCT_NAME,
	ProductEnum,
	PRODUCT_FOOTER_NAME,
	EXTERNAL_LINK_GNDI_SAO_PAULO,
	PRODUCT_LINK_IOS_STORE,
	PRODUCT_LINK_ANDROID_STORE,
} from 'presentation/constants';
import {
	GndiSaoPauloAns,
	HapvidaAppIcon,
	HapvidaIcon,
	HapvidaLogo,
} from 'presentation/components/Logos';
import {AnsLogoProps, ProductIconProps, ProductLogoProps} from '../types';
import {useThemeStore} from 'presentation/store/useThemeStore';

const theme = useThemeStore.getState().theme;

export const gndiSaoPauloData = {
	productLogo: ({invertColor, nameColor, ...props}: ProductLogoProps) => (
		<HapvidaLogo
			nameColor={nameColor || (invertColor ? theme.brand.primary.white : undefined)}
			{...props}
		/>
	),
	productIcon: (props: ProductIconProps) => <HapvidaIcon {...props} />,
	productAppIcon: (props: ProductIconProps) => <HapvidaAppIcon {...props} />,
	ansLogo: (props?: AnsLogoProps) => <GndiSaoPauloAns {...props} />,
	product: ProductEnum.GNDI,
	productCode: PRODUCT_CODE.gndi,
	productName: PRODUCT_NAME.gndi,
	footerProductName: PRODUCT_FOOTER_NAME.gndi,
	links: EXTERNAL_LINK_GNDI_SAO_PAULO,
	chatRoom: CHAT_ROOMS_GNDI_SAO_PAULO,
	iosStoreLink: PRODUCT_LINK_IOS_STORE.gndi,
	androidStoreLink: PRODUCT_LINK_ANDROID_STORE.gndi,
};
